const defaultPaqueteForm = {
    tipoVenta: null,
    // tipoPortabilidad: '',
    tipoLinea: '',
    tarifa: null,
    cacharro: null,
    installment: null,
    // isSeguro: false, // Si tiene o no seguro
    seguro: null,
    lineasAsociadas: [],
    // svas: [],
    crossSell: false,
    promotion: []
}
export default defaultPaqueteForm;